import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { ChainingAdditionalInformationType } from '../types/ChainingAdditionalInformation'

export class ChainingAdditionalInformation {
    public id: Nullable<number> = null
    public objectClass!: string
    public objectId!: number
    public isDefaultChainingSaved = false

    public constructor(data: ChainingAdditionalInformationType) {
        this.id = data.id ?? null
        this.objectClass = data.objectClass
        this.objectId = data.objectId
        this.isDefaultChainingSaved = data.isDefaultChainingSaved ?? false
    }
}
